<template>
  <div id="app">
    <Header msg="This is Header"/>
    <div class="main-view">
      <router-view/>
    </div>
    <Footer msg="This is Footer"/>
  </div>
</template>

<script>

import Header from './views/Header.vue'
import Footer from "@/views/Footer";
import { verify, watchFocus, watchStorage } from '@/util/session';
import notify from '@/util/notify';

export default {
  name: 'App',
  components: {
    Footer,
    Header
  },
  created() {
    // The cookie decides who is signed in: check once on boot, then again whenever the user returns
    // to the tab (or another tab signs in/out). The header and the hero buttons follow this state
    // instead of localStorage.
    verify();
    watchFocus(() => notify.warning('Your session has expired — please sign in again. Your order is kept.'));
    watchStorage();
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, Tahoma, Geneva, Verdana, 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2d3d;
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* Content fills the remaining height so the footer sits at the bottom (no mid-air footer on short pages) */
#app > .main-view {
  flex: 1 0 auto;
}

@media screen and (max-width: 768px) {
  #app {
    font-size: 14px;
  }
}
</style>
